import React, { FunctionComponent } from 'react';
import {Card, Icon} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import './WorkspaceSelectionWrapper.scss';

type WorkspaceSelectionWrapperProps = {

};

export const WorkspaceSelectionWrapper: FunctionComponent<WorkspaceSelectionWrapperProps> = ({ children }) => {
  return (
    <div className="workspace-selection-wrapper">
      <div className="workspace-selection-wrapper__container">
        <header className="workspace-selection-wrapper__header">
          <h1 className="workspace-selection-wrapper__header__text">Welcome back!</h1>
        </header>
        <Card className="workspace-selection-wrapper__content">
          <div className="workspace-selection-wrapper__content__title">
            <div>
              <Icon icon={IconNames.APPLICATION} />
              Select Your Workspace
            </div>
          </div>
          <div className="workspace-selection-wrapper__content__details">{children}</div>
        </Card>
      </div>
    </div>
  );
}
